export default __webpack_public_path__ + "static/media/timline.c666ac2d.svg";